module.exports = __webpack_public_path__ + "img/18_en_tramite.8946092b.png";